"use client";

import { Button, notification } from "antd";
import React from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";

import { IconErrorSvg } from "./Iconsvg";
import { ErrorBoundary } from "./Error.class";

import { store } from "../../../app";

// utils
import http from "utils/api/http";
import _local from 'utils/localStorageUtils';
import { APP_VERSION } from "utils/constants";


export function Fallback({ error, resetErrorBoundary }) {
  const { t } = useTranslation();
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div>
      <div>
        <div
          className="ant-result-icon ant-result-image"
          style={{ paddingTop: "10%" }}
        >
          <h3>{t("errors.boundaryErrorMsg")}</h3>
          <Button
            size={"large"}
            type={"primary"}
            onClick={() => {
              window.location.href = "/";
            }}
            style={{ marginBottom: 20 }}
          >
            {t("pages.btnBackToHome")}
          </Button>
          <IconErrorSvg />
        </div>
      </div>
    </div>
  );
}

export const ErrorWrapper = ({ children }) => {
  const { t } = useTranslation();

  const logError = async (error, info) => {
    const state = store.getState();
    const activeSchool = _local.getLocalSchool() || {};
    const currentURL = window.location.href;

    const errorLog = {
      stack: error.stack,
      componentStack: info,
      state: state,
      baseUrl: currentURL,
      appVersion: APP_VERSION,
      school: {
        _id: activeSchool?._id,
        key: activeSchool?.key,
        name: activeSchool?.name,
      }
    };

    let sender = await http.post("/errors", errorLog);

    notification.error({
      message: t("errors.inconvenienceErrorMsg"),
    });
  };

  return (
    <ErrorBoundary
      FallbackComponent={Fallback}
      onError={logError}
      onReset={details => {}}
    >
      {children}
    </ErrorBoundary>
  );
};
